module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_8011.58e28039.png";